import React from 'react'
import { connect } from 'react-redux' 

import { Pannellum } from "pannellum-react";

class SphereViewer extends React.Component {

  render() {
    return (
        <div>
            <div className="popup">
                <Pannellum
                width='100%'
                height='100%'
                ref="paneloide"
                orientationByDefault={false}
                image={this.props.photo}
                autoLoad/>
            </div>
        </div>
    );
  }
};

function mapStateToProps( state ){
    return { }
}

export default connect(mapStateToProps)(SphereViewer);
